/** Nom affiché d'un chapitre, identique partout : « Chapitre 3 — Choisir sa prochaine escale ». */
export const chapterLabel = (chapter) => {
  if (!chapter) return '';
  const label = chapter.label || `Chapitre ${chapter.id}`;
  return chapter.title ? `${label} — ${chapter.title}` : label;
};

/** Rang d'affichage d'un chapitre (les ids ne sont pas séquentiels : 0, 16, 1..15, 17). */
export const chapterOrder = (chapter) =>
  typeof chapter?.order === 'number' ? chapter.order : Number(chapter?.id ?? 0);

export default chapterLabel;
